import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';

import styles from '../styles/pages/return-policy.scss';

import SignupPromotion from '../shared/signup-promotion';

class ReturnPolicy extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'return-policy-title' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'return-policy-title' });
        }
    }

    render() {
        const Paragraph = (props) => (
            <div className="text-justify" style={{ paddingBottom: 10, ...props.style }}>
                {props.children}
            </div>
        );

        return (
            <Layout notShowMarginBottom>
                <div className="container">
                    <div className="row">
                        <h4 className={styles.mainText}>
                            <FormattedMessage id="return-policy-title" defaultMessage="" />
                        </h4>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className={styles.privacyBackround}>
                                <Paragraph>
                                    <FormattedMessage id="return-policy-text1" defaultMessage="" />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="return-policy-subtitle1" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle1-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle1-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="return-policy-subtitle2" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle2-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="return-policy-subtitle3" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle3-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="return-policy-subtitle4" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle4-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="return-policy-subtitle5" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle5-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle5-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="return-policy-subtitle5-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="return-policy-subtitle6" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    <FormattedMessage
                                        id="return-policy-subtitle6-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    <FormattedMessage
                                        id="return-policy-subtitle6-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    <FormattedMessage
                                        id="return-policy-subtitle6-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    <FormattedMessage
                                        id="return-policy-subtitle6-text4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    <FormattedMessage
                                        id="return-policy-subtitle6-text5"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    <FormattedMessage
                                        id="return-policy-subtitle6-text6"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(ReturnPolicy);



/** WEBPACK FOOTER **
 ** ./src/components/pages/return-policy.jsx
 **/